module.exports = __webpack_public_path__ + "assets/e8982536a43811f15814f0c0d9ea1654.jpg";